import client from "./client";

const examResultsApi = {
  // Get exam results (with optional filters: testId, class, studentId)
  list(params = {}) {
    return client.get("/exam-results", { params }).then((r) => r.data);
  },

  // Save exam results for a test (bulk create/update)
  save(testId, results) {
    return client
      .post("/exam-results", { testId, results })
      .then((r) => r.data);
  },

  // Delete exam results for a test
  removeByTest(testId) {
    return client.delete(`/exam-results/${testId}`).then((r) => r.data);
  },

  // Leaderboard: returns { classLeaderboard: [...], schoolLeaderboard: [...] }
  leaderboard(params = {}) {
    return client.get("/exam-results/leaderboard", { params }).then((r) => r.data);
  },

  // Parent acknowledgment status for a specific test (teacher only)
  parentAckStatus(testId) {
    return client.get(`/exam-results/${testId}/parent-ack-status`).then((r) => r.data);
  },
};

export default examResultsApi;
